import {BillingPueRestResource} from "../rest/billing-pue-rest-resource";
import {PUE_SERVER} from "../server";

const pueDaily = new BillingPueRestResource({server: PUE_SERVER, resource: 'PUE/daily'});

export default pueDaily;